// extracted by css-extract-rspack-plugin
var _1 = "aLE3w94msEOmVJSe";
var _2 = "aLE3w94msEOmVJSe";
var _3 = "xEKVe5mEfawz67l5";
var _4 = "xEKVe5mEfawz67l5";
var _5 = "WfPXb__vNPgNltPK";
var _6 = "WfPXb__vNPgNltPK";
var _7 = "YQenp5PPOokp7XyA";
var _8 = "YlUAfV6wdck5cZy8";
export { _1 as "draw-tabs", _2 as "drawTabs", _3 as "fixed-tabs", _4 as "fixedTabs", _5 as "hidden-tab", _6 as "hiddenTab", _7 as "loading", _8 as "tabs" }
